<div>
<h2>System Dashboard</h2>
	<p-panel class="requestPanel shareLine panel spaceLeft" header="Report/Plot Options" toggleable="true">
		<div class="flex-container">
		<div class="flex-child requestPanel">
			<input type="radio" name="dataStart" id="startDate">Start Date
			<p-datepicker [(ngModel)]="startDate" [showIcon]="true" [maxDate]="maxDate" dateFormat="mm/dd/yy" showTime="true" hourFormat="24"></p-datepicker>
			<p-divider align="center"><b>OR</b></p-divider>
			<input type="radio" name="dataStart" checked id="displayPeriodOption" class="spaceLeft">Display Period
			<p-select [options]="displayPeriodOptions" [(ngModel)]="selectedDisplayPeriod"></p-select> <!--(onClick)="printAddOn()"-->
		</div>
		<p-divider layout="vertical">
			<b>AND</b>
		</p-divider>
		<div class="flex-child">
			End Date (required)
			<p-datepicker class="spaceRight" [(ngModel)]="endDate" [showIcon]="true" [maxDate]="maxDate" dateFormat="mm/dd/yy" showTime="true" hourFormat="24">
			</p-datepicker>
		</div>
		</div>
		<p-divider></p-divider>
		<!-- refresh -->
		<button pButton pRipple title="Refresh"  (click)="refreshDates()" icon="pi pi-refresh"></button>
	</p-panel>
</div>

<p-tabs value="0">
	<p-tablist>
		@for ( report of systemReports; track report; let i = $index ) {
		<p-tab [value]="i"><span class="header">{{ report.linkName }}</span></p-tab>
		}
	</p-tablist>
	@for (report of systemReports; track report; let i = $index) {
	<p-tabpanels value="0">
		<p-tabpanel [value]="i">
			<ng-template #content>

			<div>
				<!-- if individual items aren't available, use the link associated with the general section -->
				@if ( report.links == null ) {
				<div class="ui-g-12 ui-md-3" style="text-align:center">
	                <a href={{report.link}} target="_blank">
	                	<img src={{report.image}}>
	                </a>
		        </div>
				}
		    </div>
		
			<!-- individual links are specified, use them in an accordion -->
	    	<p-accordion #links (onOpen)="reportOpened($event, report)">	<!-- maybe try cache=true since lazy was removed-->
				@if (report.links.length == 0 ) {
				<p>No {{report.linkName}} defined for this system</p>
				}
				@for ( nsdisplay of report.links; track nsdisplay; let j = $index ) {
				<p-accordion-panel [value]="j">
					<p-accordion-header>{{report.linkName}} - {{nsdisplay.label}}</p-accordion-header>
					<p-accordion-content>
						@if ( nsdisplay.display == true ) {
						<p-panel>
							<iframe width="100%" height="600" [src]="nsdisplay.fullLink | safe: 'url'"></iframe> 
						</p-panel>
						}
					</p-accordion-content>
				</p-accordion-panel>
				}
			</p-accordion>
			</ng-template>
		</p-tabpanel>
	</p-tabpanels>
	}
</p-tabs>
